import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { bp, hoverSpoofer } from 'Styles/helpers';
import Grid from '../grid';
import FeaturedProgramCard from '../featured-program-card';

const ProgramGrid = (props) => {
  if (!props.programList || props.programList.length < 1) return null;

  return (
    <ProgramGridGrid>

      {props.programList.map((program, i) => (
        <ProgramGridItem span={4} key={program.id}>
          <FeaturedProgramCard
            program={program}
            index={i}
            parentRoute={props.parentRoute}
            lazyLoad={props.lazyLoad}
          />
        </ProgramGridItem>
      ))}

    </ProgramGridGrid>
  );
};

const ProgramGridItem = styled(Grid.Item)`
  margin-top: 110px;
  overflow: hidden;

  ${screen.below(bp.desktop, `
    margin-top: 80px;
  `)}

  ${screen.below(bp.laptop, `
    margin-top: 60px;
  `)}

  ${screen.below(bp.portrait, `
    grid-column: span 6;
    margin-top: 40px;
  `)}

  ${screen.below(bp.mobileSm, `
    grid-column: span 12;
    margin-top: 60px;

    &:not(:first-of-type) {
      margin-top: 30px;
    }
  `)}
`;

const ProgramGridGrid = styled(Grid)`
  position: relative;
  align-items: stretch;

  ${hoverSpoofer(ProgramGridItem)}
`;

ProgramGrid.propTypes = {
  programList: PropTypes.arrayOf(PropTypes.object),
  lazyLoad: PropTypes.bool,
  parentRoute: PropTypes.string,
};

ProgramGrid.defaultProps = {
  parentRoute: 'programs',
};

export default ProgramGrid;
